import { head, pathOr, pipe } from 'ramda';

export const getContent = pipe(head, pathOr('', ['content']));
